import { useMemo } from "react";
import { InputComboBoxList } from "src/framework/components/forms/inputs/InputComboBoxList"
import { FormProjetoOffGridType } from "../../../types";
import { InputPrefix } from "./InputPrefix";

export const OPCOES_REMOVER_LITIO = ["24"]

export const TENSAO_SAIDA_OPTIONS = [
  {
    'id': '127',
    'nome': '127V Monofásico (CA)',
  },{
    'id': '220',
    'nome': '220V Monofásico (CA)',
  }/*,{
    'id': '127/220',
    'nome': '220V Trifásico (CA)',
  },{
    'id': '220/380',
    'nome': '380V Trifásico (CA)',
  }*/,{
    'id': '24',
    'nome': '24V (CC)',
  },{
    'id': '48',
    'nome': '48V (CC)',
  }
]

interface TensaoSaidaInputProps {
  errorState: string[];
  onChangeError: (errorState: any) => void
  formState: FormProjetoOffGridType;
  onChangeValue: (formState: Partial<FormProjetoOffGridType>) => void;
}

export const TensaoSaidaInput = ({ errorState, onChangeError, formState, onChangeValue }: TensaoSaidaInputProps) => {
  const options = useMemo(()=>{
    if (formState.tipo_bateria?.id === 'litio') {
      // Remove opções caso selecionado bateria de lítio"
      return TENSAO_SAIDA_OPTIONS.filter(item => !OPCOES_REMOVER_LITIO.includes(item.id))
    }
    
    return TENSAO_SAIDA_OPTIONS;
  },[formState.tipo_bateria])

  return (
      <InputComboBoxList
        id={"offgrid-tensao-saida-field"}
        key={`offgrid-tensao-saida-field`}
        label={"* Tensão de saída"}
        prefix={<InputPrefix styles={{ marginLeft: '-2px' }} />}
        textField="nome"
        valueField="id"
        error={errorState.includes("tensao_saida")}
        options={options}
        value={formState?.tensao_saida || null}
        renderOptions={(option: any) => {
            return `${option?.nome}`
        }}
        renderOptionsLabel={(option: any) => {
            return `${option?.nome}`
        }}
        onChange={(value) => {
          onChangeValue({ tensao_saida: value, recalcular: true })
        }}
      />
  )
}